module.exports = __webpack_public_path__ + "img/icon-login.3078d597.svg";